const FILTERS_TRANSLATION_PREFIX = 'STATIC.PAGES.ANOMALY_ANALYSIS.FILTERS';
const TIME_SELECTORS_TRANSLATION_PREFIX = `${FILTERS_TRANSLATION_PREFIX}.TIMES`;

export const TimeSelectors = {
    DAY_BY_DAY: 'DAY_BY_DAY',
    WEEK_BY_WEEK: 'WEEK_BY_WEEK',
    MONTH_BY_MONTH: 'MONTH_BY_MONTH',
};

export const TIME_OPTIONS = Object.keys(TimeSelectors).map(value => ({
    value,
    label: `${TIME_SELECTORS_TRANSLATION_PREFIX}.${value}`,
}));

export const TimePeriods = {
    [TimeSelectors.DAY_BY_DAY]: { amount: 1, unit: 'days' },
    [TimeSelectors.WEEK_BY_WEEK]: { amount: 7, unit: 'days' },
    [TimeSelectors.MONTH_BY_MONTH]: { amount: 1, unit: 'months' },
};

export const Dimensions = {
    APP: 'APP',
    SOURCE: 'SOURCE',
    PLATFORM: 'PLATFORM',
    CAMPAIGN: 'CAMPAIGN',
    COUNTRY: 'COUNTRY',
};

export const DimensionConfig = {
    [Dimensions.APP]: { label: 'STATIC.APP', apiName: 'app' },
    [Dimensions.SOURCE]: { label: `${FILTERS_TRANSLATION_PREFIX}.SOURCE`, apiName: 'source' },
    [Dimensions.PLATFORM]: { label: 'STATIC.PLATFORM', apiName: 'platform' },
    [Dimensions.CAMPAIGN]: { label: 'STATIC.CAMPAIGN', apiName: 'adn_campaign_name' },
    [Dimensions.COUNTRY]: { label: 'STATIC.COUNTRY', apiName: 'country_field' },
};

export const DIMENSIONS_OPTIONS = Object.entries(DimensionConfig).map(([value, { label }]) => ({
    value,
    label,
}));

const FILTERS_DIMENSIONS = [Dimensions.APP, Dimensions.SOURCE, Dimensions.COUNTRY];

export const FILTERS_OPTIONS = FILTERS_DIMENSIONS.map(key => ({
    value: key,
    label: DimensionConfig[key].label,
    apiName: DimensionConfig[key].apiName,
}));

export const MetricType = {
    COLOR: 'COLOR',
    SIZE: 'SIZE',
};

export const MetricsConfig = {
    REVENUE_7D: { types: [MetricType.COLOR, MetricType.SIZE], apiName: 'revenue', apiType: 'cohort', period: '7d' },
    ROI_1D: { types: [MetricType.COLOR], apiName: 'roi', apiType: 'cohort', period: '1d' },
    ROI_7D: { types: [MetricType.COLOR], apiName: 'roi', apiType: 'cohort', period: '7d' },
    ROI_14D: { types: [MetricType.COLOR], apiName: 'roi', apiType: 'cohort', period: '14d' },
    OCVR: { types: [MetricType.COLOR], apiName: 'ocvr', apiType: 'metric' },
    ECPI: { types: [MetricType.COLOR], apiName: 'ecpi', apiType: 'metric' },
    INSTALLS: { types: [MetricType.COLOR, MetricType.SIZE], apiName: 'custom_installs', apiType: 'metric' },
    COST: { types: [MetricType.SIZE], apiName: 'adn_cost', apiType: 'metric' },
    IMPRESSIONS: { types: [MetricType.SIZE], apiName: 'custom_impressions', apiType: 'metric' },
    CLICKS: { types: [MetricType.SIZE], apiName: 'custom_clicks', apiType: 'metric' },
};

export const PerformanceColorConfig = {
    NO_DATA: { color: '#D1D5DB' },
    POOR: { color: '#E85D5D', min: -Infinity, max: -15 },
    BELOW_AVG: { color: '#E8A45D', min: -15, max: -5 },
    NEUTRAL: { color: '#E2B837', min: -5, max: 5 },
    GOOD: { color: '#5DB87A', min: 5, max: 15 },
    EXCELLENT: { color: '#3DA66B', min: 15, max: Infinity },
};

export const PERFORMANCE_COLORS = Object.fromEntries(
    Object.entries(PerformanceColorConfig).map(([key, { color }]) => [key, color])
);
